import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { Input } from 'reactstrap'
import { AttachFile } from 'material-react-icons'
import TextareaAutosize from 'react-textarea-autosize'
import { withNamespaces } from 'react-i18next'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin: 15px 18px 15px 18px;

  padding: 15px 24px 15px 20px;

  border: 1px solid #eeeff1;
  border-radius: 4px;
`

const StyledIcon = styled.div`
  margin: 0 15px 0 0;
  cursor: pointer;
  transition: opacity 0.2s;

  :hover {
    opacity: 0.8;
  }
`

const StyledInput = styled(TextareaAutosize)`
  flex: 1;

  outline: none;

  border: none;

  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #2e384d;

  ::placeholder {
    color: #8798ad;
  }
`
const StyledButton = styled.button`
  border-color: transparent;
  border-radius: 4px;
  margin: 0 0 0 15px;
  padding: 5px 24px;
  color: #ffffff;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  background-color: #4c84ff;
  cursor: pointer;

  outline: none;

  transition: opacity 0.2s;

  :hover {
    opacity: 0.8;
  }
`

const StyledFileList = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin: 10px 25px 10px 30px;
`

const StyledFileItem = styled.div`
  display: flex;
  align-items: center;
  color: #8b93a7;
  margin-right: 15px;

  .iconContainer {
    margin-right: 10px;
  }

  .file_name {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    font-size: 13px;
  }

  cursor: pointer;
`

class ResponseForm extends Component {
  constructor(props) {
    super(props)

    this.fileUploadRef = React.createRef()
  }

  render() {
    const { files, messageText, t } = this.props

    return (
      <div>
        <StyledFileList>
          {files.map((file, index) => {
            return (
              <StyledFileItem
                key={file.lastModified}
                onClick={() => this.removeAttachmentHandler(index)}
              >
                <div className="iconContainer">
                  <FontAwesomeIcon size="1x" icon="trash" />
                </div>
                <div className="file_name">{file.name}</div>
              </StyledFileItem>
            )
          })}
        </StyledFileList>
        <Wrapper>
          <Input
            multiple
            innerRef={this.fileUploadRef}
            type="file"
            style={{ display: 'none' }}
            onChange={this.fileUploadHandler}
            onClick={(event) => {
              event.target.value = null
            }}
          />
          <StyledIcon onClick={this.fileUploadButtonHandler}>
            <AttachFile color="#A9B8CB" />
          </StyledIcon>
          <StyledInput
            type="textarea"
            value={messageText}
            onChange={this.textInputHandler}
            placeholder={t('tickets:keyPlaceholder')}
            minRows={1}
            maxRows={4}
          />
          <StyledButton
            disabled={messageText === ''}
            onClick={this.sendMessageHandler}
          >
            {t('common:send')}
          </StyledButton>
        </Wrapper>
      </div>
    )
  }

  textInputHandler = ({ target }) => {
    const { value } = target
    this.props.inputMessageHandler(value)
  }

  sendMessageHandler = (ev) => {
    ev.preventDefault()
    const { sendMessage } = this.props
    sendMessage()
  }

  fileUploadButtonHandler = (ev) => {
    ev.preventDefault()
    this.fileUploadRef.current.click()
  }

  fileUploadHandler = (ev) => {
    ev.preventDefault()
    const { files } = ev.target

    const _files = []

    for (let i = 0; i < files.length; i++) {
      if (files[i].size < 134217728) {
        _files.push(files[i])
      }
    }

    this.props.attachFiles(_files)
    if (files.length > _files.length) {
      this.props.showWarningFileSize()
    }
  }

  removeAttachmentHandler = (id) => {
    this.props.removeAttachment(id)
  }
}

export default withNamespaces()(ResponseForm)
